<template>
  <div id='login'>
      <div class='logo'>
          <div class="logo-line1">蓉 畅 生 物 科 技 </div>
          <div class="logo-line2">——ZUIMEIXUANYAN——</div>
      </div>
      <div class='loginform'>
          <div class='login-input'>
             <div class='login-input-icon'><Icon src='sj' class='login-input-svg'/></div><div class='login-input-content'> <input type='number' v-model='mobile' placeholder="请输入手机号码" readonly @click="showMobileInput=true"/></div>
          </div>
          <div class='login-input'>
             <div class='login-input-icon'><Icon src='yzm' class='login-input-svg'/></div><div class='login-input-content'> <input type='number' placeholder="请输入验证码" v-model='code' @click="showMobileInput=false"/></div>
             <div class="sendmsg-con" @click="getCode(2)">获取验证码</div>
          </div>
          <div class='login-btn-con'>
              <button class='login-btn' block @click='doLogin()'>登  陆</button>
          </div>
          <div class="login-zhlogin">
             <div class="login-zhlogin-con" @click="goZhlogin">
                <div class="login-zhlogin-icon"><Icon class='login-zhlogin-icon-img' src="zhlogin"/></div>
                <div class="login-zhlogin-words">账号密码登陆</div>
            </div>  
          </div>     
      </div>    
      <div class='bottomwords'>
          <div class="brow article">已阅读并同意<span class="blink" @click="goArticle(2)">《蓉畅生物科技服务协议》</span>和<span class="blink" @click="goArticle(2)">《隐私协议》</span></div>
          <div class="brow" @click="goBeian">闽ICP备20023082号-1</div>
      </div>
      <van-number-keyboard
                        :show="showMobileInput"
                        theme="custom"
                        close-button-text="完成"
                        @blur="showMobileInput = false"
                        @input="onMobileInput"
                        @delete="onMobileDelete"
                        />   
  </div>
</template>
<script>
import Icon from '@/components/icon'
import {NumberKeyboard} from 'vant'
export default {
   name: 'login',
   data() {
        return {
          mobile:'',
          code:'',
          showMobileInput:false
        };
   }, 
   methods: {
      goBeian(){
         window.location.href="https://beian.miit.gov.cn/"
     },
      doLogin(){
          if(this.mobile=='') {
              this.$toast("手机号码不能为空")
              return false
          }
          if(this.code=='') {
              this.$toast("验证码不能为空")
              return false
          }
          this.$store.dispatch("doMLogin",{mobile:this.mobile,code:this.code}).then((data)=>{
              if(data.result.success){
                this.$go('/index')  
              }else{
                this.$toast(data.result.info)
              }
          })
      },
      getCode(type){
         if(this.mobile==''|| isNaN(this.mobile)){
            this.$toast("手机号码不正确")
            return false
         } 
         this.$post("/sms/getCode",{mobile:this.mobile,type:type}).then((data)=>{
              this.$toast(data.result.info)
         })
      },
      goZhlogin(){
          this.$go("/zhlogin")
      },
      goArticle(type){
        this.$go({name:'gongkai',params:{type:type}})    
      },
      onMobileInput(input){
          this.mobile+=input
      },
      onMobileDelete(){
          this.mobile=this.mobile.slice(0,-1)
      }
   },
   components: {
        Icon,
        [NumberKeyboard.name]:NumberKeyboard
   }
}
</script>
<style scoped>
#login{background-color:#ffffff;min-height: 100vh;padding-top:60px;z-index:999;padding: 0 0.5rem;overflow:hidden;position: relative;margin:0 auto;max-width:640px;color:#2c3e50;}
.logo{margin-top:2.5rem;background-color:#fff;margin-bottom: 2rem;}
.logoimg{width:4rem;height:4rem;}
.loginform{margin-top: 0.8rem;}
.title-con{padding: 0.3rem;}
.title{font-size:0.5rem;padding: 0.2rem;color:#facb97}
.subtitle{font-size:0.3rem;padding: 0 0.1rem 0.1rem;}
.login-btn-con{margin-top: 0.5rem;}
.login-btn{width: 100%;height: 1.067rem;color: #000;text-align: center;line-height: 1.067rem;font-size: 0.36rem;border-radius: 0.2rem;background-image: linear-gradient(to right,#cccccc,#dddddd);}
.login-input{background-color: #eeeeee;height:1.2rem;margin-top: 0.2rem;border-radius: 0.2rem;display:flex;align-items: center;}
.login-input-icon{width:1.25rem;text-align: center;}
.login-input-svg{width:0.5rem;height:0.5rem;}
.login-input-content{flex:3;}
.login-input-content input{outline: none;border: none;background-color: #eeeeee;height:1rem;line-height: 1rem;width:100%;font-size:0.4rem;border-radius: 0.2rem;color:#000000;}
.forget_password{margin-top: 0.4rem;color:#7AB5FB;font-size:0.3rem;letter-spacing: 1px;}
.bottomwords{text-align: center;font-size:0.30rem;color:#000000;width:100%;margin-top:1rem;}
.login-zhlogin{display: flex;justify-content: center;}
.login-zhlogin-con{display: flex;justify-content: center;flex-flow: column nowrap;align-items: center;margin-top: 0.85rem;}
.login-zhlogin-icon-img{width:1.2rem;height:1.2rem;}
.login-zhlogin-words{font-size:0.35rem;margin-top: 0.2rem;color:#333;}
.sendmsg-con{color:#333;text-decoration: underline;width:2.5rem;text-align: center;font-size:0.35rem;padding: 0.1rem;}
.logo-line1{font-size:1.35rem;color:#000;}
.logo-line2{font-size:0.35rem;color:#000;}
.brow{padding: 0.1rem;cursor: pointer;}
.blink{font-weight: 600;}
</style>